import React, { Component } from 'react';
import i18n from '@i18next/i18n';
import ColorBaseItem from './color-base';
import { ITextEditItemsData } from './textEditDataProcesser';
import { ColorPanelType } from '@com-m/edit-panel-m/const';
import { IColorPickerManager } from '@src/slide/application/service/color-picker-manager/color-picker-manager.interface';
interface IColorEditItemProps {
    textEditData: ITextEditItemsData;
    colorPickerManager?: IColorPickerManager;
    openColorPanel(type: ColorPanelType): void;
}
interface IColorEditItemStates {
    fontSize: number;
}
export default class ColorEditItems extends Component<IColorEditItemProps, IColorEditItemStates> {
    public constructor(props) {
        super(props);
        this.state = {
            fontSize: 24,
        };
    }
    public shouldComponentUpdate(nextProps) {
        const lastFontColor = this.props?.textEditData?.editFontColor?.value;
        const lastFillColor = this.props?.textEditData?.editFillColor?.value?.color;
        const lastBorderColor = this.props?.textEditData?.editBorderColor?.value?.color;
        const fontColor = nextProps?.textEditData?.editFontColor?.value;
        const fillColor = nextProps?.textEditData?.editFillColor?.value?.color;
        const borderColor = nextProps?.textEditData?.editBorderColor?.value?.color;
        const lastDisable = this.props?.textEditData?.editFontColor?.disabled;
        const disable = nextProps?.textEditData?.editFontColor?.disabled;
        return lastFontColor !== fontColor
            || lastFillColor !== fillColor
            || lastBorderColor !== borderColor
            || lastDisable !== disable;
    }
    public render() {
        const { textEditData } = this.props;
        if (!textEditData?.editFontColor || !textEditData?.editFillColor || !textEditData?.editBorderColor) {
            return null;
        }
        return <React.Fragment>
            <ColorBaseItem
                colorPickerManager={this.props.colorPickerManager}
                id={textEditData.editFontColor.id}
                data={textEditData.editFontColor.data}
                value={textEditData.editFontColor.value}
                disabled={textEditData.editFontColor.disabled}
                colorPanelType={ColorPanelType.FONT}
                openColorPanel={() => {
                    this.props.openColorPanel(ColorPanelType.FONT);
                }}
                title={i18n.t('文字颜色')}
            />
            <ColorBaseItem
                colorPickerManager={this.props.colorPickerManager}
                id={textEditData.editFillColor.id}
                data={textEditData.editFillColor.data}
                value={textEditData.editFillColor?.value?.color}
                disabled={textEditData.editFillColor.disabled}
                colorPanelType={ColorPanelType.FILL}
                openColorPanel={() => {
                    this.props.openColorPanel(ColorPanelType.FILL);
                }}
                title={i18n.t('填充颜色')}
            />
            <ColorBaseItem
                colorPickerManager={this.props.colorPickerManager}
                id={textEditData.editBorderColor.id}
                data={textEditData.editBorderColor.data}
                value={textEditData.editBorderColor?.value?.color}
                disabled={textEditData.editBorderColor.disabled}
                colorPanelType={ColorPanelType.BORDER}
                openColorPanel={() => {
                    this.props.openColorPanel(ColorPanelType.BORDER);
                }}
                title={i18n.t('边框颜色')}
                showNoColor={true}
            />
        </React.Fragment>;
    }
}
